import React, { useState } from "react";
import { Row, Col, Spin, Form, Card, DatePicker } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";
import { connect } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import dayjs from "dayjs";

import MainLayout from "../../../../components/layouts/enhancement/MainLayout";
import TopContent from "../../../../components/layouts/enhancement/TopContent";
import cnt from "../../../../services/definedConstant";
import { rightAction } from "../../../../redux/actions";
import {
  labelConfig, staticConfig, apiConfig,
} from "../../treasuryContractBooking.config";
import { BOM } from "../../../../services/definedMethod";


const Tip = ({ text, tip }) => (
  <span>
    {text}
    <Tooltip title={tip}>
      <InfoCircleOutlined style={{ marginLeft: 4, color: "#667085" }} />
    </Tooltip>
  </span>
);

const InstructSettlement = (props) => {
  const [form]      = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const navigate    = useNavigate();
  const location    = useLocation();
  const { userData } = props;
  const { session }  = userData || {};

  const settlementId = location.state;

  const onFinish = (values) => {
    if (!settlementId) {
      BOM.AlertMsg(cnt.DANGER, "Settlement ID is missing. Please go back and try again.");
      return;
    }

    const body = {
      session,
      method: "POST",
      instructionDate: values.instructionDate.format("YYYY-MM-DD"),
    };

    const url = `${apiConfig.GetSettlements}/settlements/${settlementId}/instruct`;

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err) => {
      if (err) {
        BOM.AlertMsg(
          cnt.DANGER,
          err?.errors?.[0]?.defaultUserMessage ||
            err?.defaultUserMessage ||
            "Failed to instruct settlement. Please try again.",
        );
        setIsLoading(false);
        return;
      }

      BOM.AlertMsg(cnt.SUCCESS, "Settlement instruction sent successfully.");
      setIsLoading(false);
      navigate(-1);
    });
  };

  return (
    <MainLayout pageItems={staticConfig.manageSettlement}>
      <TopContent pageTitle={labelConfig.settlement} />

      <Spin spinning={isLoading} size="large">
        <div style={{ padding: "24px" }}>
          <Card
            style={{
              boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
              borderRadius: 20,
            }}
          >
            {/* Header */}
            <Row style={{ marginBottom: 24 }}>
              <Col>
                <h3 style={{ margin: 0, fontWeight: 600 }}>
                  Instruct Settlement
                </h3>
              </Col>
            </Row>

            <Form layout="vertical" form={form} onFinish={onFinish}>

              {/* Instruction Date */}
              <Row>
                <Col span={12} style={{ padding: "0 8px" }}>
                  <Form.Item
                    label={
                      <Tip
                        text="Instruction Date"
                        tip="The date on which the settlement instruction is being sent to S4."
                      />
                    }
                    name="instructionDate"
                    rules={[
                      {
                        required: true,
                        message: "Instruction date is required",
                      },
                    ]}
                    initialValue={dayjs()}
                  >
                    <DatePicker
                      style={{ width: "100%", height: 44 }}
                      format="YYYY-MM-DD"
                      placeholder="Select instruction date"
                      disabledDate={(current) =>
                        current && current < dayjs().startOf("day")
                      }
                    />
                  </Form.Item>
                </Col>
              </Row>

              <div
                style={{ borderTop: "1px solid #EAECF0", margin: "8px 0 20px" }}
              />

              <Row justify="end">
                <Col>
                  <button
                    type="button"
                    onClick={() => navigate(-1)}
                    style={{
                      height: 44,
                      padding: "0 24px",
                      borderRadius: 8,
                      border: "1px solid #D0D5DD",
                      background: "#fff",
                      color: "#344054",
                      fontWeight: 600,
                      fontSize: 14,
                      cursor: "pointer",
                      marginRight: 12,
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    onClick={() => form.submit()}
                    style={{
                      height: 44,
                      padding: "0 24px",
                      borderRadius: 8,
                      border: "1px solid #BA24D5",
                      background: "#BA24D5",
                      color: "#fff",
                      fontWeight: 600,
                      fontSize: 14,
                      cursor: "pointer",
                    }}
                  >
                    Send Instruction
                  </button>
                </Col>
              </Row>

              <button type="submit" hidden />
            </Form>
          </Card>
        </div>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  rightBtn: state.RightSideBtn,
  userData: state.AuthenticationData.userData,
});

export default connect(mapStateToProps, { rightAction })(InstructSettlement);